var _Defs, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Defs, G, Path } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: style */
function SvgCross(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    id: "cross_svg__Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35"
  }, props), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null)), _G || (_G = /*#__PURE__*/React.createElement(G, {
    id: "cross_svg__Header_-_Opt_1_Grey_",
    "data-name": "Header - Opt 1 (Grey)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M35 17.5C35 27.12 27.12 35 17.5 35 7.88 35 0 27.12 0 17.5 0 7.88 7.88 0 17.5 0 27.12 0 35 7.88 35 17.5z",
    fill: "none"
  }), /*#__PURE__*/React.createElement(Path, {
    className: "cross_svg__cls-2",
    transform: "rotate(-45 17.599 17.5)",
    d: "M17.1 5.01h1v25h-1z"
  }), /*#__PURE__*/React.createElement(Path, {
    className: "cross_svg__cls-2",
    transform: "rotate(-135 17.602 17.505)",
    d: "M17.1 5.01h1v25h-1z"
  }))));
}
export default SvgCross;